import React from "react";
import PropTypes from "prop-types";
import { cmsTextClass, sheetClass } from "../../styles";
import AboutContent from "../../../../components/about-content/AboutContent";

/**
 * Site1 About section: the business's own content, from the About editor.
 *
 * `title` is shown only for legacy plain-text content, which has no headings of
 * its own. Rich content is laid out by its author, and a stock "About us" over
 * a section that opens with its own headline would read as two titles. The
 * section is labelled either way, so it stays a named landmark.
 */
const AboutSection = ({ title = null, label, text, onBook, bookingLabel }) => (
  <section id="about" aria-label={title ? undefined : label} aria-labelledby={title ? "site1-about-title" : undefined} className="scroll-mt-20 py-14 md:py-20">
    <div className={sheetClass}>
      {title && (
        <h2
          id="site1-about-title"
          className={`${cmsTextClass} mt-0 mb-8 text-center text-fluid-2xl font-bold text-[var(--site1-heading)] md:mb-10`}
        >
          {title}
        </h2>
      )}
      <div className="mx-auto max-w-5xl">
        <AboutContent value={text} onBook={onBook} bookingLabel={bookingLabel} />
      </div>
    </div>
  </section>
);

AboutSection.propTypes = {
  title: PropTypes.string,
  /** The section's accessible name when it has no visible title. */
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onBook: PropTypes.func,
  bookingLabel: PropTypes.string,
};

export default AboutSection;
